// components/ReviewTemplateList/index.tsx
import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import { ApplicationTitle } from '../../../Utils/Constants';
import ReviewListNav from './ReviewListNav';
import ReviewListTabContent from './ReviewListTabContent';
import { ReviewTemplateListTitle as ReviewListTitle } from '../../../Utils/Constants'; // reuse existing constant name

export default function ReviewTemplateList() {
    const [activeTab, setActiveTab] = useState<number>(1);

    // user from local storage (same as your other pages)
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = user?.id || '';
    const role = user?.role || '';

    return (
        <>
            <Breadcrumbs pageTitle={ReviewListTitle} parent={ApplicationTitle} title={ReviewListTitle} />
            <Container fluid>
                <Row className="project-cards">
                    <Col md={12} className="project-list">
                        <ReviewListNav activeTab={activeTab} setActiveTab={setActiveTab} />
                    </Col>

                    <Col sm={12}>
                        <ReviewListTabContent activeTab={activeTab} userId={userId} role={role} />
                    </Col>
                </Row>
            </Container>
        </>
    );
}
